import { Deserializable } from '../protocols/deserializable';
import { PortalTypeIdEnum } from '../enum/shared/portal-type-id.enum';
import { OriginPortal } from './remittance-history';
import { HistoryItem } from '../../interfaces/history-item';

export class BaseRemittanceHistory implements Deserializable, HistoryItem {
  public id!: string;
  public originPortalId!: PortalTypeIdEnum;
  public originPortal!: OriginPortal;
  public event!: string;
  public eventDate!: string;

  onDeserialize(): void {
    if (this.originPortal) {
      window?.injector?.Deserialize?.instanceOf(OriginPortal, this.originPortal);
    }
  }
}
